type Fn<T, U> = (t: T) => U | null | undefined;
/** like pipe, but returns early if any of the functions return a nullish value */
export function pipeNonNull<A, B>(a: A | null | undefined, b: Fn<A, B>): B | null | undefined;
export function pipeNonNull<A, B, C>(a: A | null | undefined, b: Fn<A, B>, c: Fn<B, C>): C | null | undefined;
export function pipeNonNull<A, B, C, D>(
  a: A | null | undefined,
  b: Fn<A, B>,
  c: Fn<B, C>,
  d: Fn<C, D>,
): D | null | undefined;
export function pipeNonNull<A, B, C, D, E>(
  a: A | null | undefined,
  b: Fn<A, B>,
  c: Fn<B, C>,
  d: Fn<C, D>,
  e: Fn<D, E>,
): E | null | undefined;
export function pipeNonNull<A, B, C, D, E, F>(
  a: A | null | undefined,
  b: Fn<A, B>,
  c: Fn<B, C>,
  d: Fn<C, D>,
  e: Fn<D, E>,
  f: Fn<E, F>,
): F | null | undefined;
export function pipeNonNull<A, B, C, D, E, F, G>(
  a: A | null | undefined,
  b: Fn<A, B>,
  c: Fn<B, C>,
  d: Fn<C, D>,
  e: Fn<D, E>,
  f: Fn<E, F>,
  g: Fn<F, G>,
): G | null | undefined;
// Single implementation signature
export function pipeNonNull(a: unknown, ...fns: Array<Fn<unknown, unknown>>): unknown {
  let current = a;
  for (let i = 0; i < fns.length; i++) {
    if (current == null) {
      // If we've already hit null or undefined, just return it
      return current;
    }
    current = fns[i]!(current);
  }
  return current;
}
